/**
 * streamlines add a dynamic value to gap.
 * @param {object} param0
 * @param {number|string} param0.$gap
 * @returns {string}
 */
const dynGap = ({ $gap }) => {
  if ($gap === undefined) return "";
  if (typeof $gap === "number") return `gap: ${$gap}px;`;
  return `gap: ${$gap};`;
};

export default dynGap;
